import { IPreviewEnterpriseProratedLicenseCostState, IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers } from '.';
import { BlockedByFeature } from '../../../featureToggles/features/utils';
import { RootState } from '../../rootReducer';
import { IPreviewProratedEnterpriseLicenseCost } from './interfaces';

const getPreviewEnterpriseLicenseCostState = (state: Pick<RootState, 'accounts'>): IPreviewEnterpriseProratedLicenseCostState | undefined => {
  const previewProratedEnterpriseLicenseCostState: IPreviewProratedEnterpriseLicenseCostStateTrialsOfTiers = state.accounts.previewProratedEnterpriseLicenseCost;
  if (previewProratedEnterpriseLicenseCostState === BlockedByFeature) {
    return;
  }
  return previewProratedEnterpriseLicenseCostState;
};

const selectPreviewProratedEnterpriseLicenseCost = (state: Pick<RootState, 'accounts'>): IPreviewProratedEnterpriseLicenseCost | undefined => getPreviewEnterpriseLicenseCostState(state)?.proratedLicenseCost;
const selectLoadingPreviewProratedEnterpriseLicenseCost = (state: Pick<RootState, 'accounts'>): boolean => getPreviewEnterpriseLicenseCostState(state)?.loading ?? false;

export const selectors = {
  selectPreviewProratedEnterpriseLicenseCost,
  selectLoadingPreviewProratedEnterpriseLicenseCost
};
